<template>
	<div class="feedback-swiper-widget__container container-max">
		<div class="feedback-swiper-widget__main-headline">{{ headline }}</div>

		<div class="swiper position-relative overflow-hidden" ref="swiper">
			<div class="swiper-wrapper">
				<div class="swiper-slide feedback-swiper-widget__item" v-for="entry in listEntries">
					<div class="feedback-swiper-widget__stars-wrapper">
						<div class="feedback-swiper-widget__stars">
							<svg xmlns="http://www.w3.org/2000/svg" width="89" height="14" viewBox="0 0 89 14" fill="none">
								<path d="M7 0L8.5716 4.83688H13.6574L9.5429 7.82624L11.1145 12.6631L7 9.67376L2.8855 12.6631L4.4571 7.82624L0.342604 4.83688H5.4284L7 0Z" fill="#e9ebef"/>
								<path d="M25.6667 0L27.1634 4.83688H32.007L28.0885 7.82624L29.5852 12.6631L25.6667 9.67376L21.7481 12.6631L23.2449 7.82624L19.3263 4.83688H24.1699L25.6667 0Z" fill="#e9ebef"/>
								<path d="M44.333 0L45.9046 4.83688H50.9904L46.8759 7.82624L48.4475 12.6631L44.333 9.67376L40.2185 12.6631L41.7901 7.82624L37.6756 4.83688H42.7614L44.333 0Z" fill="#e9ebef"/>
								<path d="M62.9997 0L64.4964 4.83688H69.3401L65.4215 7.82624L66.9182 12.6631L62.9997 9.67376L59.0811 12.6631L60.5779 7.82624L56.6593 4.83688H61.5029L62.9997 0Z" fill="#e9ebef"/>
								<path d="M81.667 0L83.2386 4.83688H88.3244L84.2099 7.82624L85.7815 12.6631L81.667 9.67376L77.5525 12.6631L79.1241 7.82624L75.0096 4.83688H80.0954L81.667 0Z" fill="#e9ebef"/>
							</svg>

							<div class="feedback-swiper-widget__stars-active" :style="'max-width: ' + entry.stars + '%'">
								<svg xmlns="http://www.w3.org/2000/svg" width="89" height="14" viewBox="0 0 89 14" fill="none">
									<path d="M7 0L8.5716 4.83688H13.6574L9.5429 7.82624L11.1145 12.6631L7 9.67376L2.8855 12.6631L4.4571 7.82624L0.342604 4.83688H5.4284L7 0Z" fill="#F9B900"/>
									<path d="M25.6667 0L27.1634 4.83688H32.007L28.0885 7.82624L29.5852 12.6631L25.6667 9.67376L21.7481 12.6631L23.2449 7.82624L19.3263 4.83688H24.1699L25.6667 0Z" fill="#F9B900"/>
									<path d="M44.333 0L45.9046 4.83688H50.9904L46.8759 7.82624L48.4475 12.6631L44.333 9.67376L40.2185 12.6631L41.7901 7.82624L37.6756 4.83688H42.7614L44.333 0Z" fill="#F9B900"/>
									<path d="M62.9997 0L64.4964 4.83688H69.3401L65.4215 7.82624L66.9182 12.6631L62.9997 9.67376L59.0811 12.6631L60.5779 7.82624L56.6593 4.83688H61.5029L62.9997 0Z" fill="#F9B900"/>
									<path d="M81.667 0L83.2386 4.83688H88.3244L84.2099 7.82624L85.7815 12.6631L81.667 9.67376L77.5525 12.6631L79.1241 7.82624L75.0096 4.83688H80.0954L81.667 0Z" fill="#F9B900"/>
								</svg>
							</div>
						</div>
					</div>
					<div class="feedback-swiper-widget__headline">{{ entry.headline }}</div>
					<div class="feedback-swiper-widget__text" v-html="entry.txt"></div>
					<div class="feedback-swiper-widget__btn-wrapper">
						<a :href="url" class="feedback-swiper-widget__btn">{{ linkTxt }}</a>
					</div>
				</div>
			</div>
			<div class="swiper-pagination"></div>
			<div ref="prev" class="swiper-button-prev">
				<svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none">
					<path fill-rule="evenodd" clip-rule="evenodd" d="M0.799805 11.0024L1.82617 12L7.99948 6L1.82617 0L0.799805 0.997554L5.94674 6L0.799805 11.0024Z" fill="white"/>
				</svg>
			</div>
			<div ref="next" class="swiper-button-next">
				<svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none">
					<path fill-rule="evenodd" clip-rule="evenodd" d="M0.799805 11.0024L1.82617 12L7.99948 6L1.82617 0L0.799805 0.997554L5.94674 6L0.799805 11.0024Z" fill="white"/>
				</svg>
			</div>
		</div>
	</div>
</template>

<script>

import { Swiper } from 'swiper';

	export default {
		props: {
			listEntries: Array,
			headline: String,
			url: String,
			linkTxt: String,
		},

		mounted(){
			this.initSwiper()
		},


		methods: {
			initSwiper(){
				var swiper = new Swiper(this.$refs.swiper, {
					spaceBetween: 14,
					slidesPerView : 1,
					navigation: {
						nextEl: this.$refs.next,
						prevEl: this.$refs.prev,
					},
					breakpoints: {
						// when window width is >= 320px
						768: {
							slidesPerView : 2.4,
						},
						576: {
							slidesPerView : 1.5,
						},
					}
				});
			}
		}
	}
</script>
